import { makeRequest } from '../client'

export const addOrder = (data) => {
  return makeRequest('order', 'createPublicOrder', data)
}

export const getOrderHistory = (restaurantId, customerId) => {
  return makeRequest('order', 'getOrders', { restaurantId, customerId })
}

export const getOrderStatus = (restaurant_id, order_id) => {
  return makeRequest('order', 'getOrderById', { restaurant_id, orderId: order_id })
}
